<template>
  <v-content class="reset-password-view gradient-oblique">
    <v-container grid-list-lg class="max-width-500">
      <v-form id="recupero-password-form" v-model="form.valid" ref="form" lazy-validation @submit.prevent="validateForm">
        <v-layout justify-center row wrap>

          <v-flex xs12 class="mt-4">
            <v-img src="./img/logo.svg" contain width="130px" height="130px" class="ma-auto"/>
          </v-flex>

          <v-flex xs12 class="text-xs-center mb-3">
            <div class="display-3 font-weight-light white--text">SprayerManager</div>
          </v-flex>

          <!-- In caso di successo mostro il messaggio di conferma -->
          <template v-if="done">

            <v-flex xs12 class="mt-5">
              <v-icon color="success" size="100" class="ma-auto d-flex">check_circle</v-icon>
            </v-flex>

            <v-flex xs12 class="text-xs-center">
              <div class="display-1 font-weight-light white--text">{{ $t('reset_password.messaggi.success') }}</div>
            </v-flex>

          </template>

          <!-- Altrimenti mostro la form con i dati -->
          <template v-else>

            <v-flex xs12 class="text-xs-center mb-3">
              <div class="title font-weight-light white--text">{{ $t('reset_password.label.inserisci_token') }}</div>
            </v-flex>

            <v-flex xs12>
              <text-field :label="$t('label.token')" v-model="form.token" show-details box dark color="white" required/>
            </v-flex>

            <v-flex xs12>
              <password-field
                :label="$t('inputs.password.nuovo')"
                v-model="form.newPassword"
                show-details box dark color="white"
                required
                :v-rules="[...$utils.rules.password]"/>
            </v-flex>

            <v-flex xs12>
              <password-field
                :label="$t('inputs.password.reinserisci_nuovo')"
                v-model="form.newPasswordConfirm"
                show-details box dark color="white"
                required
                :v-rules="[(v => v === form.newPassword || $t('errori.password_diverse')), ...$utils.rules.password]"/>
            </v-flex>

            <v-flex xs12 class="text-xs-right">
              <v-btn type="submit" form="recupero-password-form" :disabled="!form.valid" :loading="form.sending" color="white" class="mx-0" block round>
                {{ $t('reset_password.azioni.conferma_modifica_password') }}
              </v-btn>
            </v-flex>

          </template>

        </v-layout>
      </v-form>
    </v-container>
  </v-content>
</template>

<script>
import { PasswordField } from '@/components/inputs'

export default {
    name: 'ResetPassword',
    components: { PasswordField },
    data: () => ({
        done: false,
        form: {
            sending: false,
            valid: true,
            token: '',
            newPassword: '',
            newPasswordConfirm: ''
        }
    }),
    methods: {
        validateForm () {
            if (this.$refs.form.validate()) {
                this.onConfirm()
            }
        },
        onConfirm () {
            this.form.sending = true
            this.$api.tecnici.resetPassword(this.form.token, this.form.newPassword, this.form.newPasswordConfirm).then(response => {
                this.form.sending = false
                this.done = true
            }).catch(e => {
                this.form.sending = false
                if (e.response && (e.response.status === 401 || e.response.status === 408)) {
                    this.$snackbar.show(this.$t('errori.token_errato'), 'error')
                } else {
                    this.$snackbar.showServerError(e)
                }
            })
        }
    }
}
</script>
<style lang="scss">
  .reset-password-view {

    .error--text {
      $error: #ff6e30;
      color: $error !important;
    }

  }
</style>
